
export function initResize(){
    let el = document.querySelector(".menu-wrapper")
    window.onresize = function(event) {
        jQuery(".menu-wrapper").removeAttr('style');
        el.classList.remove('opened');
        ScrollTrigger.refresh();
    };
}


